
// ToDo: maybe move to `app` module

import EventDispatcher from './EventDispatcher';
import createEventGeneric from './events/generic';
import { getModule } from './modules';

import Log from './log';
const log = Log.getLogger('MultiSceneForApp.core.instance');

let _instance = {};
let _store = null;

/**
 * Adds a listener to an event type.
 *
 * @param {string} type - the type of event to listen to
 * @param {Function} listener - the function that gets called when the event is fired
 */
function addEventListener(type, listener) {
    _getEvents().addEventListener(type, listener);
}

function dispatchEvent(event) {
    _getEvents().dispatchEvent(event);
}

function dispatchEventWithGeneric(event) {
    _getEvents().dispatchEvent(event);
    _getEvents().dispatchEvent(createEventGeneric(event));
}

/**
 * Definition of command.
 *
 * @typedef {Object} MultSceneForApp~commandDefinition
 * @property {string} command - name of command (moduleId.commandId)
 * @property {Object} [params] - parameters of command
 */

/**
 * Executes command.
 *
 * @param {MultSceneForApp~commandDefinition} commandDefinition - definition of command
 */
 function executeCommand(commandDefinition) {
    if (commandDefinition && commandDefinition.command) {
        let arr = commandDefinition.command.split('.');
        if (arr.length === 2) {
            let module = getModule(arr[0]);
            if (module) {
                if (_store) {
                    module.executeCommand(
                        commandDefinition,
                        (action) => {
                            _store.dispatch(action);
                        },
                        _store
                    );
                } else {
                    log.warn(`_store not initialized`);
                }
            }
        }
    }
}

function _getEvents() {
    return getInstance().events;
}

function getInstance() {
    return _instance;
}

function getStore() {
    return _store;
}

function initInstance() {
    _instance.events = new EventDispatcher()
}

/**
 * Removes a listener from an event type.
 *
 * @param {string} type - the type of the listener that gets removed
 * @param {Function} listener - the listener function that gets removed
 */
function removeEventListener(type, listener) {
    _getEvents().removeEventListener(type, listener);
}

function setStore(store) {
    _store = store;
}

export {
    addEventListener,
    dispatchEvent,
    dispatchEventWithGeneric,
    executeCommand,
    getInstance,
    getStore,
    initInstance,
    removeEventListener,
    setStore
};
